import { IBrandReviewsSummary } from '../../indigofair/data/IBrandReviewsSummary';
import { IFaireMoney } from '../../indigofair/data/IFaireMoney';
import { IImage } from '../../indigofair/data/IImage';
import { IProduct } from '../../indigofair/data/IProduct';

export namespace IRetailerBrandFollow {
  export enum FollowSource {
    FOLLOW_SOURCE_UNKNOWN = 'FOLLOW_SOURCE_UNKNOWN',
    RETAILER = 'RETAILER',
    ORDER = 'ORDER',
    MARKET_LIST = 'MARKET_LIST',
  }

  /**
   * Redacted copy of IRetailerBrandFollow (i.e. without redacted fields).
   */
  export type Redacted = Omit<IRetailerBrandFollow, 'id'>;

  /**
   * Return an instance of IRetailerBrandFollow with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IRetailerBrandFollow>
  ): IRetailerBrandFollow =>
    ({
      products: [],
      ...(partial ?? {}),
    }) as IRetailerBrandFollow;
}

export interface IRetailerBrandFollow {
  retailer_token: string | undefined;
  brand_token: string | undefined;
  brand_name: string | undefined;
  brand_profile_image: IImage | undefined;
  brand_based_in_city: string | undefined;
  brand_based_in_state: string | undefined;
  /**
   * Deprecated, use brandReviewsSummary.averageRating instead
   * @deprecated
   */
  brand_overall_rating: number | undefined;
  brand_first_order_minimum: IFaireMoney | undefined;
  brand_reorder_minimum: IFaireMoney | undefined;
  products: Array<IProduct>;
  updated_at: number | undefined;
  /**
   * [REDACTED]
   * @protobufOption (indigofair.data.redacted) = true
   */
  id: number | undefined; // redacted
  /**
   * Used to display discount matching on mobile during the FWM/FSM.
   */
  brand_promo_string: string | undefined;
  /**
   * @deprecated
   */
  faire_winter_market_apparel_preorder_special_eligibility: boolean | undefined;
  /**
   * Used to represent if brand is enrolled into preferred partner
   */
  loyalty_program_enrolled: boolean | undefined;
  /**
   * isHighlightedBrandForPromotionalEvent is used to highlight brands during a promotional event.
   * This will mirror the behavior used during FWM 2021 in faireWinterMarketApparelPreorderSpecialEligibility,
   * which highlighted apparel preorder brands. For the FSM 2021, this will be used to highlight international brands.
   */
  is_highlighted_brand_for_promotional_event: boolean | undefined;
  /**
   * True if the brand qualifies as a Top Shop for the current cycle
   */
  is_top_shop: boolean | undefined;
  brand_reviews_summary: IBrandReviewsSummary | undefined;
}
